const chartColumns = [[
    'datetime',
    'Date',
]]

export default chartColumns
